/**
 * @type {{D2: "2D", D3: "3D"}} DimensionType
 */
export const DimensionType = {
  D2: "2D",
  D3: "3D",
};
